/**
 * Styl čáry.
 */
enum LineStyle {
    /**
     * Plná čára.
     */
    SOLID = 'solid',

    /**
     * Čárkovaná čára.
     */
    DASHED = 'dashed',
}

export default LineStyle;
